module.exports = __webpack_public_path__ + "img/youtube.1838f36.svg";